// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__12u4y","Div":"CustomFadeBox_Div__3Ftam"};